// extracted by mini-css-extract-plugin
export var bottomsection = "IntroRehomingCentre-module--bottomsection--06781";
export var headingsection = "IntroRehomingCentre-module--headingsection--745df";
export var location = "IntroRehomingCentre-module--location--cecbb";
export var text = "IntroRehomingCentre-module--text--faf52";